import React, {
  useRef,
  useEffect,
} from "react";
import { useAuth } from "../../navigation/AuthProvider";

import { FaGripVertical, FaCommentDots} from "react-icons/fa";


const ShiftCard = ({
  shift,
  shiftGroupId,
  employee,
  empIndex,

  selectedEmployee,

  allEmployees,
  allProjects,
  allAbsenceRules,

  selectedShiftIds,
  selectedDates,

  deleteMode,
  deleteType,

  setSelectedShiftIds,
  setSelectedDates,

  setIsEditing,
  setEditWorksession,
  setShiftFormData,
  setSelectEmployeePopupVisible,

  getWholeShiftAbsence,

  employeeList,

  shiftIndex,

  variant,
  tooltip,
  baseBg,
  start,
  end,
  projectName,

  isOpenForApplications,

  styleForVariant,
  badgeForVariant,
  applicationBadge,
}) => {

  const { company } = useAuth();

  const SIDENAV_WIDTH = 250;

  const cardRef = useRef(null);

  const isCopyingRef = useRef(false);

  useEffect(() => {

    const handleKeyDown = (e) => {

      if (
        e.altKey ||
        e.ctrlKey ||
        e.metaKey
      ) {
        isCopyingRef.current = true;
      }
    };

    const handleKeyUp = () => {
      isCopyingRef.current = false;
    };

    window.addEventListener(
      "keydown",
      handleKeyDown
    );

    window.addEventListener(
      "keyup",
      handleKeyUp
    );

    return () => {

      window.removeEventListener(
        "keydown",
        handleKeyDown
      );

      window.removeEventListener(
        "keyup",
        handleKeyUp
      );
    };
  }, []);

  if (
    selectedEmployee.length > 0 &&
    employee.employeeId !== selectedEmployee
  ) {
    return null;
  }

  const this_employee = allEmployees.find(
    (emp) => emp._id === employee.employeeId
  );

  const employeeName = employee?.employeeId
    ? this_employee?.name || "N/A"
    : "Anställd saknas";

  const slotMissing = !employee.employeeId;

  const wholeShiftAbsence = getWholeShiftAbsence(
    shift,
    employee
  );

  const wholeShiftAbsent = !!wholeShiftAbsence;

  const absenceName = wholeShiftAbsence
    ? allAbsenceRules.find(
        (a) => a._id === wholeShiftAbsence.absenceType
      )?.name || "Frånvaro"
    : null;

  const slotStyle = wholeShiftAbsent
    ? {
        backgroundColor: "#FEF9C3",
        border: "1px solid #FDE68A",
      }
    : slotMissing
      ? shift.allowApplications
        ? {
            borderLeft: "4px solid #10B981",
            backgroundColor: "#F0FDF4",
          }
        : {
            backgroundColor: "#FEE2E2",
            border: "1px solid #FCA5A5",
          }
      : {};

  const slotTooltip = slotMissing
    ? "Ofullständigt skift: Anställd saknas."
    : tooltip;

  const isSelectedShift = selectedShiftIds.has(
    shift._id
  );

  const isSelectedDay = selectedDates.has(
    shift.date
  );

  const isSelected =
    deleteMode &&
    (
      (deleteType === "shift" && isSelectedShift) ||
      (deleteType === "day" && isSelectedDay)
    );

  return (
    <div
      ref={cardRef}
      className="shift-entry"
      title={slotTooltip}
      style={{
        backgroundColor: baseBg,
        position: "relative",
        overflow: "hidden",

        ...styleForVariant(
          variant,
          isOpenForApplications
        ),

        ...slotStyle,

        ...(isSelected && {
          backgroundColor: "#7f1d1d",
          color: "white",
          border: "1px solid #ef4444",
        }),
      }}
      onClick={() => {

        if (deleteMode) {

          if (deleteType === "shift") {

            setSelectedShiftIds((prev) => {

              const next = new Set(prev);

              if (next.has(shift._id)) {
                next.delete(shift._id);
              } else {
                next.add(shift._id);
              }

              return next;
            });

          } else if (deleteType === "day") {

            setSelectedDates((prev) => {

              const next = new Set(prev);

              if (next.has(shift.date)) {
                next.delete(shift.date);
              } else {
                next.add(shift.date);
              }

              return next;
            });
          }

          return;
        }

        setIsEditing(true);

        setEditWorksession(shift);

        console.log("shift --> ", shift)

        setShiftFormData({
          employees: employeeList.length
            ? employeeList
            : [
                {
                  employeeId: "",
                  overtime: [],
                  absences: [],
                  breaks: [],
                },
              ],

          project: shift.project || "",

          date: shift.date || "",

          startTime:
            shift.startTime || "",

          endTime:
            shift.endTime || "",

          allowApplications:
            shift.allowApplications || false,

          disableBreakTime:
            !!shift.disableBreakTime,

          breakStartTime:
            shift.breakStartTime || "",

          breakEndTime:
            shift.breakEndTime || "",

          message:
            shift.message || "",
        });

        setSelectEmployeePopupVisible(
          true
        );
      }}
    >


    {/* DRAG HANDLE */}
    {company?.advancedSchedulingEnabled && (
      <div
        draggable={!deleteMode}

        onDragStart={(e) => {

          const startX = e.clientX;

          if (startX <= SIDENAV_WIDTH) {
            e.preventDefault();
            return;
          }

          e.stopPropagation();

          window.dispatchEvent(
            new Event("shift-drag-start")
          );

          document.body.style.cursor =
            isCopyingRef.current
              ? "copy"
              : "grabbing";

          // IMPORTANT
          e.dataTransfer.effectAllowed =
            "copyMove";

          if (isCopyingRef.current) {
            e.dataTransfer.dropEffect =
              "copy";
          }

          e.dataTransfer.setData(
            "shiftId",
            shift._id
          );

          e.dataTransfer.setData(
            "employeeIndex",
            empIndex
          );

          // COPY MODE
          e.dataTransfer.setData(
            "copyMode",
            isCopyingRef.current
              ? "true"
              : "false"
          );

          const groupEl = document.querySelector(
            `[data-shift-group="${shiftGroupId}"]`
          );

          if (groupEl) {

            const rect =
              groupEl.getBoundingClientRect();

            const offsetX =
              e.clientX - rect.left;

            const offsetY =
              e.clientY - rect.top;

            // CLONE ONLY FOR DRAG PREVIEW
            const dragPreview =
              groupEl.cloneNode(true);

            dragPreview.style.position =
              "fixed";

            dragPreview.style.top =
              "-99999px";

            dragPreview.style.left =
              "-99999px";

            dragPreview.style.pointerEvents =
              "none";

            dragPreview.style.zIndex =
              "-1";

            document.body.appendChild(
              dragPreview
            );

            e.dataTransfer.setDragImage(
              dragPreview,
              offsetX,
              offsetY
            );

            // cleanup
            requestAnimationFrame(() => {
              document.body.removeChild(
                dragPreview
              );
            });
          }
        }}

        onDragEnd={() => {
          window.dispatchEvent(
            new Event("shift-drag-end")
          );

          document.body.style.cursor = "default";

          isCopyingRef.current = false;
        }}

        onClick={(e) =>
          e.stopPropagation()
        }

        style={{
          position: "absolute",
          top: 8,
          left: 6,

          width: 18,
          height: 18,

          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          cursor: "grab",

          color: isSelected
            ? "white"
            : "#6B7280",

          borderRadius: 4,

          opacity: 0.6,

          zIndex: 5,
        }}
      >
        <FaGripVertical size={12} />
      </div>
    )}

      {!shift.allowApplications &&
        (variant || slotMissing) &&
        badgeForVariant(
          "red",
          slotTooltip
        )}

      {shift.allowApplications &&
        !employee.employeeId &&
        applicationBadge(true)}

      {wholeShiftAbsent && (
        <span
          title={`${absenceName} – hela passet`}
          style={{
            position: "absolute",
            top: 6,
            right: 6,

            padding: "2px 6px",

            borderRadius: 6,

            fontSize: 10,

            fontWeight: 700,

            backgroundColor: "#FEF3C7",

            color: "#92400E",

            border:
              "1px solid #FDE68A",

            zIndex: 2,

            maxWidth: "90%",

            overflow: "hidden",

            textOverflow: "ellipsis",

            whiteSpace: "nowrap",
          }}
        >
          {absenceName}
        </span>
      )}

      <p
        className="subtle-strong"
        style={{
          fontSize: "14px",
          paddingLeft:
          company?.advancedSchedulingEnabled
            ? 22
            : 0,

          color: isSelected
            ? "white"
            : undefined,
        }}
      >
        <strong
          style={{
            color: "inherit",
          }}
        >
          {employeeName}
        </strong>
      </p>

      <p
        style={{
          fontSize: "14px",
          paddingLeft:
          company?.advancedSchedulingEnabled
            ? 22
            : 0
        }}
      >
        {start} - {end}

        {Array.isArray(
          employee.overtime
        ) &&
          employee.overtime.length > 0 && (
            <span
              style={{
                marginLeft: 5,
                color: "grey",
              }}
            >
              + övertid
            </span>
          )}
      </p>

      <p
        style={{
          fontSize: "14px",
          paddingLeft:
          company?.advancedSchedulingEnabled
            ? 22
            : 0
        }}
      >
        {projectName}
      </p>
      {shift.message?.trim() && (
  <div
    title={shift.message}
    style={{
      position: "absolute",
      bottom: 6,
      right: 6,

      width: 18,
      height: 18,

      borderRadius: "50%",

      background: "#2563EB",

      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      color: "white",

      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",

      zIndex: 1,
    }}
  >
    <FaCommentDots size={9} />
  </div>
)}
    </div>
  );
};

export default ShiftCard;